import React from "react";

const CustomCard = ({
  children,
  className = "",
  ...props
}) => {
  return (
    <div className="custom-card-container">
      <div
        className={`custom-card ${className}`}
        {...props}
      >
        {children}
      </div>
    </div>
  );
};

export default CustomCard;
